import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
toast.configure();

function CreateTag() {

  const history = useHistory();
  const [name, setName] = useState();
  const [tagFor, setFor] = useState();
  useEffect(() => {
    let token = localStorage.getItem("token");
    
  }, []);

  const onNameChange = (e) => {
    setName([e.target.value]);
  };
  
  const onTagForChange = (e) => {
    setFor([e.target.value]);
  };
  


  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("name", name);
    formData.append("tag_for", tagFor);

    axios
      .post(URL_API + "auth/admin/tags", formData)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/tags");
          toast.success("Tag Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Add Tag</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="audi"
                    onChange={(e) => onNameChange(e)}
                  />
                </div>
                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Tag For
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="Enter   estate or blogs"
                    onChange={(e) => onTagForChange(e)}
                  />
                </div>
                <br />

                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default CreateTag;
